import React, { useState } from 'react';
import { Business, UserTierInfo } from '../../../types/accounting';

interface BusinessSelectorProps {
  businesses: Business[];
  selectedBusiness: Business | null;
  onSelectBusiness: (business: Business) => void;
  onCreateNew: () => void;
  userTier: UserTierInfo | null;
}

const BusinessSelector: React.FC<BusinessSelectorProps> = ({
  businesses,
  selectedBusiness,
  onSelectBusiness,
  onCreateNew,
  userTier
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const canCreateNew = userTier && userTier.usage 
    ? userTier.usage.business_count < userTier.limits.max_businesses
    : false;

  return (
    <div className="business-selector">
      <div className="dropdown">
        <button
          className="btn-primary dropdown-trigger"
          style={{"padding":"0.25rem","margin":"0.25rem"}}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>

              {selectedBusiness ? selectedBusiness.business_name : 'Select Business'}
              {selectedBusiness?.is_sample && <span className="sample-badge" style={{ marginLeft: '0.5rem' }}>Sample</span>}
            
          </span>
          <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
            ▼
          </span>
        </button>

        {isOpen && (
          <div className="dropdown-menu">


            <div className="business-list">
              {businesses.map(business => (
                <button
                  key={business.id}
                  className={`btn-secondary business-option ${selectedBusiness?.id === business.id ? 'active' : ''}`}
                  style={{"padding":"0.25rem"}}
                  onClick={() => {
                    onSelectBusiness(business);
                    setIsOpen(false);
                  }}
                >
                  
                    {business.business_name}
                    {business.is_sample && <span className="sample-badge" style={{ marginLeft: '0.5rem' }}>Sample</span>}
                  
                </button>
              ))}
            </div>

            <div className="dropdown-footer">
              {canCreateNew ? (
                <button
                  className="btn-primary create-new-button"
                  style={{"padding":"0.25rem","marginTop":"0.25rem"}}
                  onClick={() => {
                    onCreateNew();
                    setIsOpen(false);
                  }}
                >
                  <span className="plus-icon">+</span>
                  Create My Business
                </button>
              ) : (
                <div className="create-disabled">
                  <span className="limit-text">
                    Business limit reached ({userTier?.limits.max_businesses})
                  </span>
                  <a href="/account" className="upgrade-link">
                    Upgrade to create more
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {isOpen && (
        <div 
          className="dropdown-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default BusinessSelector;